import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { Alert, autoinject, bind, inject, Loader, TasksStore } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { DisplaysStore } from '../../DisplaysStore';
import { Button } from 'reactstrap';

export interface IAdminSettingsViewParams {
    readonly serialNumber: string;
}

export interface IAdminSettingsProps extends RouteComponentProps<IAdminSettingsViewParams> {}

@autoinject
@observer
export class AdminSettings extends React.Component<IAdminSettingsProps> {
    public render() {
        return (
            <div className="container-fluid px-2 px-md-4">
                <div className="row">
                    <div className="col-md-4 py-2">
                        <h4>Clear Software Update Exception</h4>
                        Clears the exception in the Software Update Status for this display in the database
                    </div>
                    <div className="col-md-8">
                        <div className="d-flex h-100 align-items-center">
                            <Button onClick={this.onClick} color="primary" disabled={this.disabled} className="ms-auto">
                                <Loader loading={this.loading} showSpinner message="Clearing..." />
                                {!this.loading && <span>Clear</span>}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    @bind
    @action
    private async onClick() {
        this.loading = true;
        const task = this.tasksStore.startSessionTask(
            'Clear ' + this.props.match.params.serialNumber + ' Update Exception'
        );
        try {
            const response = await this.displaysStore.clearSoftwareUpdateStatusException(
                this.props.match.params.serialNumber
            );
        } catch (e: any) {
            task.error(e.message);
        } finally {
            this.loading = false;
            this.disabled = true;
            task.complete();
        }
    }

    @observable
    private loading = false;
    @observable
    private disabled = false;
    @inject
    private displaysStore!: DisplaysStore;
    @inject private readonly tasksStore!: TasksStore;
}
